import React from 'react';
import './products.scss';
import ProductBox from './ProductBox';
import { FaChevronDown, FaTimes } from 'react-icons/fa';
import { IoMdSearch, IoMdCloseCircleOutline } from 'react-icons/io';
import { MdSort } from 'react-icons/md';
import { FiFilter } from 'react-icons/fi';
import { connect } from 'react-redux';
import { getDatabaseAction } from '../../redux/actions/actions';
import notFound from '../../images/products/not-found.png';
import SelectCurrency, { style } from '../util/SelectCurrency';
import Select from 'react-select';
import $ from 'jquery';
import ReactLoading from 'react-loading';
import Footer from '../footer/Footer';
import paypalPaymentMethods from '../../images/products/PayPal-payment.png';
import { Helmet } from 'react-helmet';


import categories, { otherCategories } from "../../objects/categories";




const TITLE_ASC = 'title asc';
const TITLE_DESC = 'title desc';
const PRICE_ASC = 'price asc';
const PRICE_DESC = 'price desc';
const AUTHOR_ASC = 'author asc';
const AUTHOR_DESC = 'author desc';

const BY_TITLE = 'by title';
const BY_AUTHOR = 'by author';

const IP = 'ip';
const OTHERS = 'others';

/**
 * TODO: use the App component's state lastProductPage to bring that page next time user enters this component
 */

/**
 * Products Component.
 * It contains an aside area with the 'filter' and the 'sort' areas and
 * a main area with a list of products sorted/filtered according with
 * user's request
 */
class Products extends React.Component {

   constructor(props) {
      super(props);

      this.state = {
         products: [],
         numberViewItems: 15,
         currentProductsPage: props.lastProductPage,
         search: props.search,
         searchType: props.searchType,
         searchToggleUp: false,
         filter: props.filter,
         filterToggleUp: false,
         sort: props.sort,
         sortToggleUp: false
      }
      this.newScreen = true;

      this.handleChangeCurrentProductsPage = this.handleChangeCurrentProductsPage.bind(this);
      this.handleSetNumberViewItems = this.handleSetNumberViewItems.bind(this);

      this.handleSearchChange = this.handleSearchChange.bind(this);
      this.handleTypeOfSearchChange = this.handleTypeOfSearchChange.bind(this);
      this.handleClearSearch = this.handleClearSearch.bind(this);

      this.handleFilterChange = this.handleFilterChange.bind(this);
      this.handleFilterToggleChange = this.handleFilterToggleChange.bind(this);

      this.handleSortChange = this.handleSortChange.bind(this);
      this.handleSortToggleChange = this.handleSortToggleChange.bind(this);

      const rgb = { backgroundColor: '#4D5162' };
      this.bgSelectedButton = rgb;

      
      
      
   }

   componentDidMount() {
      this.props.dispatch(getDatabaseAction());
      if (this.props.filter) {
         this.setState({
            filter: this.props.filter
         })
      }
      if (!this.state.search) $('.sb-search-content').hide();
      $('.sb-filter-content').hide();
      $('.sb-sort-content').hide();
      if (this.props.lastProductsPage) {
         this.setState({
            currentProductsPage: this.props.lastProductsPage
         })
      }
      this.props.setHideNavSearch(true);
   }

   componentDidUpdate() {
      $('footer').hide();
      if (this.props.lastProductsPage) {
         this.setState({
            currentProductsPage: this.props.lastProductsPage
         })
      }
   }

   componentWillUnmount() {
      $('footer').show();
      if (this.state.search && !this.state.products.length) {
         this.handleSearchChange(null, true);
      }
      this.props.setHideNavSearch(false);
   }  



   handleSetNumberViewItems(numberViewItems) {
      if (this.state.currentProductsPage > Math.ceil(this.state.products.length / numberViewItems.value)) {
         this.setState({
            numberViewItems: numberViewItems.value,
            products: [],
            currentProductsPage: Math.ceil(this.state.products.length / numberViewItems.value)
         });
      } else {
         this.setState({
            numberViewItems: numberViewItems.value,
            products: []
         });
      }
   }



   handleChangeCurrentProductsPage(newProductsPage, scrollToTop = false) {
      if (typeof newProductsPage === 'number' && this.state.currentProductsPage !== newProductsPage) {
         this.setState({
            currentProductsPage: newProductsPage,
            products: []
         }, () => {
            this.props.updateLastProductPage(this.state.currentProductsPage);
            if (scrollToTop) {
               window.scroll(0,0)
            }
         });
      }
      else if (typeof newProductsPage === 'number' && this.state.currentProductsPage === newProductsPage) {
         // Do nothing! Ignore this occurrence of the function.
      }
      else {
         const lastPage = Math.ceil(this.state.products.length / this.state.numberViewItems);
         let value = { newPage: 1, condition: this.state.currentProductsPage !== 1};
         
         if (newProductsPage === '<') value.newPage = this.state.currentProductsPage - 1;
         else if (newProductsPage === '>') {
            value = { 
               newPage: this.state.currentProductsPage + 1,
               condition: this.state.currentProductsPage !== lastPage
            }
         } else if (newProductsPage === '>>') {
            value = {
               newPage: lastPage,
               condition: this.state.currentProductsPage !== lastPage
            }
         }

         if (value.condition) {
            
            this.setState({
               currentProductsPage: value.newPage,
               products: []
            }, () => {
               this.props.updateLastProductPage(this.state.currentProductsPage);
               if (scrollToTop) {
                  window.scroll(0,0)
               }
            });
         }
      }
   }


   handlePublisherChange(publisher) {
      this.props.setPublisher(publisher);
      this.handleChangeCurrentProductsPage(1, true);
      this.handleFilterChange('', true);
   }



   handleSearchChange(e, cancelSearch = false) {
      if (cancelSearch) {
         this.setState({
            search: '',
            currentProductsPage: 1,
            products: []
         });
         this.props.setSearch('');
      }
      else {
         this.setState({
            search: e.target.value,
            currentProductsPage: 1,
            products: []
         });
         this.props.setSearch(e.target.value)
      }
   }



   handleClearSearch() {
      this.setState({
         search: '',
         products: []
      }, () => {
         if (window.innerWidth > 900) {
            document.getElementById('search-input').focus();
         }
         this.props.setSearch('');
      });
   }

   handleTypeOfSearchChange(type) {
      this.setState({
         searchType: type,
         products: []
      }, () => {
         this.props.setSearchType(type);
      });
   }

   createSearchToggleButton() {
      if (this.newScreen) {
         this.newScreen = false;
         return <div className="sb-icon"><FaChevronDown/></div>
      } else {
         if(this.state.searchToggleUp) {
            return <div className="sb-icon rotate-icon-up"><FaChevronDown/></div>
         }
         else {
            return <div className="sb-icon rotate-icon-down"><FaChevronDown/></div>
         }
      }
   }

   handleSearchToggleChange() {
      $('.sb-search-content').toggle('fast');
      this.setState({
         searchToggleUp: !this.state.searchToggleUp
      }, () => {
         if (this.state.searchToggleUp) {
            document.getElementById('search-input').focus();
         } else {
            document.getElementById('search-input').blur();
         }
      });
   }

   /**
    * Click event handler.
    * It will change this.state.filter from previous value to the string
    * received through filter parameter. It does that in order to filter
    * the products list by subject.
    * 
    * @param {Event object} e Event object
    * @param {string} filter The string to assign to this.state.filter
    */
   handleFilterChange(filter, cancelFilter = false) {
      if (cancelFilter) {
         this.setState({
            filter,
            products: []
         }, () => {
            this.props.setFilter(filter);
            this.props.updateLastProductPage(1);
         });
      }
      else {
         $('.sb-filter-content').toggle();
         this.setState({
            filter,
            currentProductsPage: 1,
            products: [],
            filterToggleUp: !this.state.filterToggleUp
         }, () => {
            this.props.setFilter(filter);
         });
      }
   }

   handleFilterToggleChange() {
      $('.sb-filter-content').toggle('fast');
      this.setState({
         filterToggleUp: !this.state.filterToggleUp
      });
   }


   createFilterToggleButton() {
      if (this.newScreen) {
         this.newScreen = false;
         return <div className="sb-icon"><FaChevronDown/></div>
      } else {
         if(this.state.filterToggleUp) {
            return <div className="sb-icon rotate-icon-up"><FaChevronDown/></div>
         }
         else {
            return <div className="sb-icon rotate-icon-down"><FaChevronDown/></div>
         }
      }
   }




   /**
    * Click event handler.
    * It will change this.state.sort from previous value to the string
    * received through sort parameter. It does that in order to sort
    * the products list by title, price or author. Ascending or descending.
    * 
    * @param {string} sort The string to assign to this.state.sort
    */
   
   handleSortChange(sort) {
      if (sort === '') {
         const sorts = document.forms[0];
         for (let i = 0; i < sorts.length; i++) {
            if (sorts[i].checked) sorts[i].checked = false;
         }
         this.setState({
            sort,
            products: []
         }, () => this.props.setSort(sort));
      } 
      if(sort !== this.state.sort) {
         this.setState({
            sort,
            products: []
         }, () => this.props.setSort(sort));
      }
   }

   handleSortToggleChange() {
      $('.sb-sort-content').toggle('fast');
      this.setState({
         sortToggleUp: !this.state.sortToggleUp
      });
   }
   
   createSortToggleButton() {
      if (this.newScreen) {
         this.newScreen = false;
         return <div className="sb-icon"><FaChevronDown/></div>
      } else {
         if(this.state.sortToggleUp) {
            return <div className="sb-icon rotate-icon-up"><FaChevronDown/></div>
         }
         else {
            return <div className="sb-icon rotate-icon-down"><FaChevronDown/></div>
         }
      }
   }


   /**
    * Creates a new filter button.
    * It creates the button based on the state of the component (this.filter).
    * if the filter param matches to the this.filter the button will have a
    * lighter background color.
    * 
    * @param {string} filter The filter value to assign to this.filter
    * @param {string} uiText The text value to be placed in the button legend
    */
   // createFilterButton(filter, uiText) {
   //    if(this.state.filter === filter) {
   //       return <div className="sb-content-buttons" style={this.bgSelectedButton}  onClick={(e) => this.handleFilterChange(e, filter)}>{uiText}</div>
   //    }
   //    return <div className="sb-content-buttons" onClick={(e) => this.handleFilterChange(e, filter)}>{uiText}</div>
   // }
   createFilterButton(filter, text = null, i) {
      if(this.state.filter === filter) {
         return <div key={i} className="d-flex flex-column justify-content-center sb-content-buttons" style={this.bgSelectedButton}  onClick={() => this.handleFilterChange(filter)}>{text ? text : filter}</div>
      }
      return <div key={i} className="d-flex flex-column justify-content-center sb-content-buttons" onClick={() => this.handleFilterChange(filter)}>{text ? text : filter}</div>
   }

   createSearchResultLegend(numberOfProducts, list) {
      const options = [
         { value: 5, label: '5' },
         { value: 10, label: '10' },
         { value: 15, label: '15' },
         { value: 20, label: '20' },
         { value: 30, label: '30' },
         { value: 50, label: '50' },
      ];

      if(this.state.search) {
         return (
            <div className="pl-legend d-flex justify-content-between">
               {
                  numberOfProducts > 0 ?
                  <p>Showing {list.length} out of {numberOfProducts} results for "<span className="font-weight-bold">{this.state.search}</span>"</p> :
                  <p>There are no results for "<span className="font-weight-bold">{this.state.search}</span>"</p>
               }
               <div>
               <div>
                  <label htmlFor="view-number">Show:</label>
                  <Select id="view-number" onChange={this.handleSetNumberViewItems} options={options} value={this.state.numberViewItems} styles={style} placeholder={this.state.numberViewItems}/>
                  
               </div>
               <SelectCurrency setCurrency={this.props.setCurrency} currency={this.props.currency}/>
               </div>
            </div>
         )
      } else {
         return (
            <div className="pl-legend d-flex justify-content-between">
               <p>Showing {list.length} out of {numberOfProducts} products</p>
               <div className="d-flex flex-column align-items-end">
                  <div className="pl-view-number d-flex">
                     <label htmlFor="view-number">Show:</label>
                     <Select id="view-number" onChange={this.handleSetNumberViewItems} options={options} value={this.state.numberViewItems} styles={style} placeholder={this.state.numberViewItems} selected/>
                     
                  </div>
                  <SelectCurrency  setCurrency={this.props.setCurrency} currency={this.props.currency}/>
               </div>
               
            </div>
         )
      }
   }


   /**
    * Sorts the current array of product objects.
    * 
    * @param {array} list 
    */
   getSorted(list) {
      switch(this.state.sort) {
         case TITLE_ASC:
            return list.sort((a, b) => {
               if (a.title > b.title) return 1;
               else if (a.title < b.title) return -1;
               return 0;
            });
         case TITLE_DESC:
            return list.sort((a, b) => {
               if (a.title > b.title) return -1;
               else if (a.title < b.title) return 1;
               return 0;
            });
         case PRICE_ASC:
            //ascending canadias dolar
            if (this.props.currency === 'CAD') {
               return list.sort((a, b) => {
                  return a.priceCad - b.priceCad
               });
            }
            //ascending american dolar 
            else {
               return list.sort((a, b) => {
                  return a.priceUsd - b.priceUsd
               });
            }
         case PRICE_DESC:
            //descending canadian dollar
            if (this.props.currency === 'CAD') {
               return list.sort((a, b) => {
                  return b.priceCad - a.priceCad
               });
            } 
            //descending american dollar
            else {
               return list.sort((a, b) => {
                  return b.priceUsd - a.priceUsd
               });
            }
         case AUTHOR_ASC:
            return list.sort((a, b) =>{
               if (a.author > b.author) return 1;
               else if (a.author < b.author) return -1;
               return 0;
            });
         case AUTHOR_DESC:
            return list.sort((a, b) =>{
               if (a.author > b.author) return -1;
               else if (a.author < b.author) return 1;
               return 0;
            });
         default:
            return list;
      }
   }


   /**
    * Populates an array of JSX list containing the selected products by type/subject
    */
   populateProductsList() {
      let list = [];
      if (this.props.publisher === IP) {
         list = [...this.props.books]
      } else {
         const allCategories = this.props.otherProducts.map(cat => {
            const prods = cat.filter(prod => {
               // if (!prod.)
               if (prod.stock) return true;
               return false;
            });
            return [...prods];
         });
         for (let i = 0; i < allCategories.length; i++) {
            list = [...list, ...allCategories[i]];
         }
      }

      if (this.state.filter) {
         list = list.filter(prod => {
            if (this.props.publisher === IP) {
               for (let i = 0; i < prod.category.length; i++) {
                  if(prod.category[i] === this.state.filter) {
                     return prod;
                  }
               }
            } else if (this.props.publisher === OTHERS) {
               return (prod.category[0] === this.state.filter);
            }
            return null
         });
      }

      // Checking if there is any searching being made
      if (this.state.search) {
         const regex = new RegExp(`${this.state.search}`, 'i');
         if (this.state.searchType === BY_TITLE) {
            list = list.filter(prod => {
               if (prod.subtitle) {
                  if (prod.title.match(regex) || prod.subtitle.match(regex)) return prod;
                  return null;
               } else {
                  if (prod.title.match(regex)) return prod;
                  return null;
               }
            });
         } else{
            list = list.filter(prod => {
               if (prod.author) {
                  if (prod.author.match(regex)) return prod;
               }
               return null;
            });
         }
      }

      if (JSON.stringify(this.state.products) !== JSON.stringify(list)) {
         this.setState({
            products: list
         });
      }
   }


   getSearchModifications() {
      const search = this.state.search ? (
         <div key="search" className="search-modification d-flex justify-content-between align-items-center">
            <p>Search: "{this.state.search}" {this.state.searchType}</p>
            <span onClick={() => this.handleSearchChange('', true)}><IoMdCloseCircleOutline /></span>
         </div>
      ) : null;

      const filter = this.state.filter ? (
         <div key="filter" className="search-modification d-flex justify-content-between align-items-center">
            <p>Filter: {this.state.filter}</p>
            <span onClick={() => this.handleFilterChange('', true)}><IoMdCloseCircleOutline /></span>
         </div>
      ) : null;
      
      const sort = this.state.sort && this.props.sort !== TITLE_ASC ? (
         <div key="sort" className="search-modification d-flex justify-content-between align-items-center">
            <p>Sort: {this.state.sort.substring(0,1).toUpperCase() + this.state.sort.substring(1)}ending</p>
            <span onClick={() => this.handleSortChange('')}><IoMdCloseCircleOutline /></span>
         </div>
      ) : null;

      return (
         <div className="p-modifications">
            {
               [search, filter, sort]
            }
         </div>
      );
   }

   getNumberPagesHtml(scrollToTop) {
      const numberPages = Math.ceil(this.state.products.length / this.state.numberViewItems) + 1;
      let ps = [];
      const shouldBeCenter = (this.state.currentProductsPage > 2 && this.state.currentProductsPage < numberPages - 2);
      if (numberPages <= 5) {
         for (let i = 1; i < numberPages; i++) {
            const isSamePage = (i === this.state.currentProductsPage);
            ps.push(<p key={i} className="text-primary" onClick={() => this.handleChangeCurrentProductsPage(i, scrollToTop)} style={isSamePage ? {backgroundColor:'#ddd'} : {}}>{i}</p>);
         }
         return ps;
      } else {
         if (shouldBeCenter) {
            for (let i = this.state.currentProductsPage - 2; i <= this.state.currentProductsPage + 2; i++) {
               const isSamePage = (i === this.state.currentProductsPage);
               ps.push(<p key={i} className="text-primary" onClick={() => this.handleChangeCurrentProductsPage(i, scrollToTop)} style={isSamePage ? {backgroundColor:'#ddd'} : {}}>{i}</p>);
            }
         }
         else {
            if (this.state.currentProductsPage <= 2) {
               for (let i = 1; i <= 5; i++) {
                  const isSamePage = (i === this.state.currentProductsPage);
                  ps.push(<p key={i} className="text-primary" onClick={() => this.handleChangeCurrentProductsPage(i, scrollToTop)} style={isSamePage ? {backgroundColor:'#ddd'} : {}}>{i}</p>);
               }
            }
            else {
               for (let i = numberPages - 5; i < numberPages; i++) {
                  const isSamePage = (i === this.state.currentProductsPage);
                  ps.push(<p key={i} className="text-primary" onClick={() => this.handleChangeCurrentProductsPage(i, scrollToTop)} style={isSamePage ? {backgroundColor:'#ddd'} : {}}>{i}</p>);
               }
            }
         }
         return ps;
      }
   }

   /**
    * Renders the component
    */
   render() {

      this.populateProductsList();
      const sortedList = this.getSorted(this.state.products);
      const numberOfProducts = sortedList.length;
      
      const productsList = sortedList.map((prod, index) => {
         const end = this.state.numberViewItems * this.state.currentProductsPage;
         const begin = end - this.state.numberViewItems;
         const range = [];

         for (let i = begin; i < end; i++) {
            range.push(i);
         }
         if(range.includes(index)) {
            return <li key={prod.ipNumber}><ProductBox currency={this.props.currency} product={prod} updateCartStorage={this.props.updateCartStorage}/></li>
         }
         return null;
      });

      const listPresented = [];

      productsList.forEach(val => {
         if (val) {
            listPresented.push(val);
         }
      });

      // Values to be placed in the page meta information
      const title = this.state.filter ? 'Christian Books and Media on ' + this.state.filter : 'Christian Books and Media';
      const metaDescDefault = 'Browse our products and find what interest you the most.';
      const metaDescFilter = 'Browse our products on ' + this.state.filter + '.';

      return (
         <div className="container-fluid">

            <Helmet>
               <title>{title}</title>
               <meta name="keywords" content="books, historical books, reformed books, reformed books for children, fiction books, reformed church, historical fiction, historical fiction books, short stories, liturgy, reformed worship, 80 years war, 30 years war, world war 2, Bible books, Christian books, Christian literature, literature, Psalm CDs, Hymn CDs, DVDs, Music DVDs, audio books, sheet music, church sheet music, Dutch sheet music, Psalm sheet music, organ sheet music"/>
               <meta name="description" content={"Inheritance Publications offers a variety of reformed content in form of books, audio books, CDs, DVDs & much more. " + (this.state.filter ? metaDescFilter : metaDescDefault)}/>
            </Helmet>

            <div className="row products">

               {/* Begin of search/filter/sort area */}
               <div className="sb-back"></div>
               <aside className="search-bar">
                  {this.state.products.length === 0 && !this.state.search && this.props.publisher === IP ?
                     <div className="p-products-loading d-flex justify-content-center align-items-center">
                        <ReactLoading type="spin" color="#2D3142" />
                     </div>
                     : null
                  }


                  {/* Search */}
                  <div className="sb-search">
                     
                     <div className="sb-heading" onClick={() => this.handleSearchToggleChange()}>
                        <h3><span className="sb-icon" id="search-icon"><IoMdSearch/></span> Search</h3>
                        {this.createSearchToggleButton()}
                     </div>

                     <div className="sb-search-content">

                        <div className="sb-search-input">
                           <input id="search-input" type="search" placeholder="Search product..." value={this.state.search} onChange={(e) => this.handleSearchChange(e)}></input>
                           
                           {this.state.search ? <div className="clear-input" onClick={() => this.handleClearSearch()}><FaTimes/></div> : null}
                        </div>
                        
                        
                        <div className="sb-search-details">
                           <div className="sb-s-details-title">
                              <input type="radio" name="search-filter" id="s-title" onClick={() => this.handleTypeOfSearchChange(BY_TITLE)} onChange={() =>  {}} checked={this.state.searchType === BY_TITLE}></input>
                              <label htmlFor="s-title">By title</label>
                           </div>
                           <div className="sb-s-details-title">
                              <input type="radio" name="search-filter" id="s-author" onClick={() => this.handleTypeOfSearchChange(BY_AUTHOR)} onChange={() =>  {}} checked={this.state.searchType === BY_AUTHOR}></input>
                              <label htmlFor="s-author">By author</label>
                           </div>
                        </div>

                     </div>
                  </div>


                  {/* filter */}
                  <div className="sb-filter">

                     <div className="sb-heading sb-filter-heading" onClick={() => this.handleFilterToggleChange()}>
                        <h3><span className="sb-icon" id="filter-icon"><FiFilter/></span> Filter</h3>
                        {/* <div className="d-flex">
                           <FiFilter/>
                           <h3>Filter</h3>
                        </div> */}
                        {this.createFilterToggleButton()}
                     </div>

                     <div className="sb-filter-content">
                        {/* filter buttons creation */}
                        {this.createFilterButton('', 'All')}
                        {
                           this.props.publisher === IP ?
                           Object.values(categories).map((cat, i) => this.createFilterButton(cat, null, i)) :
                           Object.values(otherCategories).map((cat, i) => this.createFilterButton(cat, null, i))
                        }
                     </div>
                  </div>


                  {/* sort */}
                  <div className="sb-sort">
                     <div className="sb-heading sb-sort-heading" onClick={() => this.handleSortToggleChange()}>
                        <h3><span className="sb-icon" id="sort-icon"><MdSort/></span> Sort</h3>
                        {this.createSortToggleButton()}
                     </div>

                     <form className="sb-sort-content">
                        <div className="checkboxes">
                           <input type="radio" id="title-asc" name="sort" onClick={() => this.handleSortChange(TITLE_ASC)} defaultChecked={this.state.sort === TITLE_ASC ? true : false}></input>
                           <label htmlFor="title-asc">Title Ascending</label>
                        </div>
                        <div className="checkboxes">
                           <input type="radio" id="title-desc" name="sort" onClick={() => this.handleSortChange(TITLE_DESC)} defaultChecked={this.state.sort === TITLE_DESC ? true : false}></input>
                           <label htmlFor="title-desc">Title Descending</label>
                        </div>
                        <div className="checkboxes">
                           <input type="radio" id="price-asc" name="sort" onClick={() => this.handleSortChange(PRICE_ASC)} defaultChecked={this.state.sort === PRICE_ASC ? true : false}></input>
                           <label htmlFor="price-asc">Price Ascending</label>
                        </div>
                        <div className="checkboxes">
                           <input type="radio" id="price-desc" name="sort" onClick={() => this.handleSortChange(PRICE_DESC)} defaultChecked={this.state.sort === PRICE_DESC ? true : false}></input>
                           <label htmlFor="price-desc">Price Descending</label>
                        </div>
                        <div className="checkboxes">
                           <input type="radio" id="author-asc" name="sort" onClick={() => this.handleSortChange(AUTHOR_ASC)} defaultChecked={this.state.sort === AUTHOR_ASC ? true : false}></input>
                           <label htmlFor="author-asc">Author Ascending</label>
                        </div>
                        <div className="checkboxes">
                           <input type="radio" id="author-desc" name="sort" onClick={() => this.handleSortChange(AUTHOR_DESC)} defaultChecked={this.state.sort === AUTHOR_DESC ? true : false}></input>
                           <label htmlFor="author-desc">Author Descending</label>
                        </div>
                     </form>
                  </div>
                  
                  {this.getSearchModifications()}

                  
                  <div className="sb-publisher">
                     <legend>Publisher</legend>
                     <div className="sb-p-inputs d-flex flex-column">
                        <div className="d-flex">
                           <input id="publisher-ip" name="publisher" type="radio" value={IP} onChange={e => this.handlePublisherChange(IP)} checked={this.props.publisher === IP ? true : false}/>
                           <label htmlFor="publisher-ip">Inheritance Publications</label>
                        </div>
                        
                        <div>
                           <input id="publisher-others" name="publisher" type="radio" value={OTHERS} onChange={e => this.handlePublisherChange(OTHERS)} checked={this.props.publisher === OTHERS ? true : false}/>
                           <label htmlFor="publisher-others">Others</label>
                        </div>
                     </div>
                  </div>

                  <div className="payment-options p-3 d-flex justify-content-center">
                     <img src={paypalPaymentMethods} alt="PayPal Payment Methods"/>
                  </div>
               </aside>
               {/* End of search/filter/sort area */}
               
               {/* Products list */}
               <main className="products-list">
                  
                  {this.createSearchResultLegend(numberOfProducts, listPresented)}

                  {this.state.products.length > 0 ? 
                     <div className='page-index-container d-flex justify-content-center align-items-center'>
                        <div className="page-index d-flex">
                           <p onClick={() => this.handleChangeCurrentProductsPage('<<')}>{'<<'}</p>
                           <p onClick={() => this.handleChangeCurrentProductsPage('<')}>{'<'}</p>
                           {this.getNumberPagesHtml(false)}
                           <p onClick={() => this.handleChangeCurrentProductsPage('>')}>{'>'}</p>
                           <p onClick={() => this.handleChangeCurrentProductsPage('>>')}>{'>>'}</p>
                        </div>
                     </div> :
                     null
                  }
                  
                  {this.state.products.length > 0 ? 
                     <div className="pl-list">
                        <ul>
                           {listPresented}
                        </ul>
                     </div> : this.state.search ?
                     <div className="not-found d-flex justify-content-center">
                        <img src={notFound} alt="Not Found!" />
                     </div> :
                     <div className="d-flex justify-content-center" style={{height: '100vh'}}>
                        <ReactLoading type={'spin'} color="#2D3142"/>
                     </div>
                  }

                  {this.state.products.length > 0 ?
                     <div className='page-index-container d-flex justify-content-center align-items-center'>
                        <div className="page-index d-flex">
                           <p onClick={() => this.handleChangeCurrentProductsPage('<<', true)}>{'<<'}</p>
                           <p onClick={() => this.handleChangeCurrentProductsPage('<', true)}>{'<'}</p>
                           {this.getNumberPagesHtml(true)}
                           <p onClick={() => this.handleChangeCurrentProductsPage('>', true)}>{'>'}</p>
                           <p onClick={() => this.handleChangeCurrentProductsPage('>>', true)}>{'>>'}</p>
                        </div>
                     </div> :
                     null
                  }

                  
                  <Footer isThiner={true}/>
               </main>
            </div>
         </div>
      )
   }
}

/**
 * Establishes the component state from the redux store whenever the store
 * is updated.
 * 
 * @param {object} state The current redux state
 */
const mapStateToProps = state => {
   const books = Object.values(state.books);
   const otherProducts = [];

   books.forEach(val => {
      if (typeof val.priceCad !== 'number') val.priceCad = Number(val.priceCad);
      if (typeof val.priceUsd !== 'number') val.priceUsd = Number(val.priceUsd);
   });

   if ('usedDutch' in state.otherProducts) {
      otherProducts.push(Object.values(state.otherProducts.usedDutch))
      otherProducts[otherProducts.length - 1].forEach((val, i) => convertProductValues(val));
   }
   if ('adultFiction' in state.otherProducts) {
      otherProducts.push(Object.values(state.otherProducts.adultFiction));
      otherProducts[otherProducts.length - 1].forEach((val, i) => convertProductValues(val));
   }
   if ('CDs' in state.otherProducts) {
      otherProducts.push(Object.values(state.otherProducts.CDs))
      otherProducts[otherProducts.length - 1].forEach(val => convertProductValues(val))
   }
   if ('CDs' in state.otherProducts) {
      otherProducts.push(Object.values(state.otherProducts.DVDs))
      otherProducts[otherProducts.length - 1].forEach(val => convertProductValues(val))
   }
   if ('usedEnglishBooks' in state.otherProducts) {
      otherProducts.push(Object.values(state.otherProducts.usedEnglishBooks))
      otherProducts[otherProducts.length - 1].forEach(val => convertProductValues(val))
   }
   if ('generalEnglishBooks' in state.otherProducts) {
      otherProducts.push(Object.values(state.otherProducts.generalEnglishBooks))
      otherProducts[otherProducts.length - 1].forEach(val => convertProductValues(val))
   }
   if ('biblesAndTheology' in state.otherProducts) {
      otherProducts.push(Object.values(state.otherProducts.biblesAndTheology))
      otherProducts[otherProducts.length - 1].forEach(val => convertProductValues(val))
   }
   if ('churchHistory' in state.otherProducts) {
      otherProducts.push(Object.values(state.otherProducts.churchHistory))
      otherProducts[otherProducts.length - 1].forEach(val => convertProductValues(val))
   }

   if ('dutch' in state.otherProducts) {
      otherProducts.push(Object.values(state.otherProducts.dutch))
      otherProducts[otherProducts.length - 1].forEach(val => convertProductValues(val))
   }

   if ('sheetMusic' in state.otherProducts) {
      otherProducts.push(Object.values(state.otherProducts.sheetMusic))
      otherProducts[otherProducts.length - 1].forEach(val => convertProductValues(val))
   }
   
   return {
      books,
      otherProducts
   }
}

function convertProductValues(val) {
   if (typeof val.priceCad !== 'number') val.priceCad = Number(val.priceCad);
   if (typeof val.priceUsd !== 'number') val.priceUsd = Number(val.priceUsd);
   if (typeof val.stock !== 'number') val.stock = Number(val.stock);
   return val;
}

// It connects the redux store to the Products props
export default connect(mapStateToProps)(Products);